import axios from '../../app/axios';
import { endpoints } from '../../utils/constants';
import RequestHeaders from '../../enums/RequestHeaders';
import PaymentDC, { ContactPaymentTotalDC } from 'src/db/entities/payment/PaymentDC';
import PaymentEntity, { ContactPaymentTotal } from 'src/db/entities/payment/PaymentEntity';
import {
  mapContactPaymentTotalDCToEntity,
  mapPaymentDCToEntity,
  mapPaymentDraftToCreatePayload,
  mapPaymentDraftToUpdatePayload,
  PaymentDraft,
} from 'src/db/entities/payment/mapper';

const workspaceHeaders = (workspaceId: string) => ({
  headers: { [RequestHeaders.WORKSPACE_ID]: workspaceId },
});

export const createPayment = async (
  draft: PaymentDraft,
  workspaceId: string
): Promise<PaymentEntity> => {
  const response = await axios.post<PaymentDC>(
    endpoints.payments.list,
    mapPaymentDraftToCreatePayload(draft),
    workspaceHeaders(workspaceId)
  );

  return mapPaymentDCToEntity(response.data, workspaceId);
};

export const updatePayment = async (
  draft: PaymentDraft,
  workspaceId: string
): Promise<PaymentEntity> => {
  const response = await axios.patch<PaymentDC>(
    endpoints.payments.list,
    mapPaymentDraftToUpdatePayload(draft),
    workspaceHeaders(workspaceId)
  );

  return mapPaymentDCToEntity(response.data, workspaceId);
};

export const deletePayment = async (uuid: string, workspaceId: string): Promise<void> => {
  await axios.delete<true>(
    endpoints.payments.delete.replace('{uuid}', uuid),
    workspaceHeaders(workspaceId)
  );
};

/** Money figures of one contact, one row per currency. */
export const fetchContactPaymentTotals = async (
  contactId: string,
  workspaceId: string
): Promise<ContactPaymentTotal[]> => {
  const response = await axios.get<ContactPaymentTotalDC[]>(endpoints.payments.contactTotals, {
    ...workspaceHeaders(workspaceId),
    params: { contact_id: contactId },
  });

  return response.data.map(mapContactPaymentTotalDCToEntity);
};
